import { FC } from "react";
import { useTranslation } from "react-i18next";
import Button from "Components/UI/Button";
import emptyActivities from "../../../../../../Static/images/empty-activity-listVision.png";
import emptySearch from "../../../../../../Static/images/empty-search.png";
import { Container } from "./styles";
import { Icon } from "Components/UI";

interface ICustomEmptyData {
  search?: boolean;
  searchText?: string;
  hasFilters?: boolean;
  onOpenCreateActivity?: () => void;
  height: number;
}

const CustomEmptyData: FC<ICustomEmptyData> = ({
  search,
  searchText,
  hasFilters,
  onOpenCreateActivity,
  height,
}) => {
  const { t } = useTranslation('activities');
  return (
    <Container height={height}>
      <img
        src={search ? emptySearch : emptyActivities}
        className={search ? 'imgSearch' : 'imgEmpty'}
        alt=""
      />
      <span className="title">
        {search && t('empty.searchTitle', { query: searchText })}
        {!search && hasFilters
          ? t('empty.filterTitle')
          : t('empty.noActivitiesTitle')}
      </span>
      <span className="subtitle">
        {search && t('empty.searchDesc')}
        {!search && hasFilters
          ? t('empty.filterDesc')
          : t('empty.noActivities')}
      </span>
      {!search && !hasFilters && (
        <Button
          className="button"
          type="primary"
          height={37}
          onClick={onOpenCreateActivity}
        >
          <Icon
            icon="adicionar"
            customSize={13}
            className="buttonIcon"
          />
          <span className="buttonText">{t('createModal.newActivity')}</span>
        </Button>
      )}
    </Container>
  )
}

export default CustomEmptyData;